import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useMemo, useEffect, useCallback } from 'react';
import { HighlightEventSource, useHighlight } from '../../../highlight/index';
function getRowStyle(isActive, rowStyle = {}, disableDefaultRowStyle) {
    const { hover = {}, active = {}, base = {}, activated = {} } = rowStyle;
    const hoverStyle = disableDefaultRowStyle
        ? hover
        : { backgroundColor: '#ff6f0091', ...hover };
    const activeStyle = disableDefaultRowStyle
        ? active
        : { backgroundColor: '#ff6f0070', ...active };
    const baseStyle = disableDefaultRowStyle
        ? base
        : { backgroundColor: 'white', ...base };
    return css([
        {
            ...baseStyle,
            ...(isActive && { backgroundColor: '#ff6f0070', ...activated }),
        },
        { ':hover': hoverStyle, ':active': activeStyle },
    ]);
}
function getIDs(row) {
    const id = row.original.id;
    if (id) {
        if (Array.isArray(id)) {
            return id;
        }
        else {
            return [String(id)];
        }
    }
    return [''];
}
function ReactTableRow(props) {
    const { row, highlightedSource = HighlightEventSource.UNKNOWN, onContextMenu, onClick, isRowActive = false, rowStyle, disableDefaultRowStyle, } = props;
    const data = useMemo(() => ({
        type: highlightedSource,
        extra: row.original,
    }), [highlightedSource, row]);
    const highlight = useHighlight(getIDs(row), data);
    useEffect(() => {
        return () => {
            highlight.hide();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const clickHandler = useCallback((event) => {
        onClick?.(event, row);
    }, [onClick, row]);
    return (_jsx("tr", { onContextMenu: onContextMenu, css: getRowStyle(highlight.isActive || isRowActive, rowStyle, disableDefaultRowStyle), ...row.getRowProps(), ...highlight.onHover, children: row.cells.map((cell) => {
            const { style, padding } = cell.column;
            if (cell.isRowSpanned) {
                return null;
            }
            else {
                return (_jsx("td", { rowSpan: cell.rowSpan, ...cell.getCellProps(), onContextMenu: (e) => {
                        e.preventDefault();
                        return false;
                    }, style: { padding, ...style }, onClick: clickHandler, children: cell.render('Cell') }, cell.key));
            }
        }) }, row.getRowProps().key));
}
export default ReactTableRow;
